import { useQuery } from '@tanstack/react-query';
import { gqlClient, graphql, queryClient } from '@tyro/api';
import { smsKeys } from './keys';

const smsBalance = graphql(/* GraphQL */ `
  query communications_currentBalance {
    communications_currentBalance {
      currentBalance
    }
  }
`);

const smsBalanceQuery = () => ({
  queryKey: smsKeys.spend(),
  queryFn: () => gqlClient.request(smsBalance),
  staleTime: 0,
});

export function useSmsBalance() {
  return useQuery({
    ...smsBalanceQuery(),
    select: ({ communications_currentBalance }) =>
      communications_currentBalance?.currentBalance ?? 0,
  });
}

export function getSmsBalance() {
  return queryClient.fetchQuery(smsBalanceQuery());
}
